import { queryOptions, useQuery } from '@tanstack/react-query'
import { getTeachers } from '../services/getTeachers.service'
import { teachersKeys } from '../constants/teachers.queryKeys'
import type { TeacherListParams } from '../types/teacher.types'

export const teachersQueryOptions = (params: TeacherListParams = {}) =>
  queryOptions({
    queryKey: teachersKeys.list(params),
    queryFn: () => getTeachers(params),
  })

export function useTeachers(params: TeacherListParams = {}) {
  return useQuery(teachersQueryOptions(params))
}
